const UNAVAILABLE = new Set(['no_planning', 'incomplete_planning']);

function formatOeeMetric(metric) {
    if (metric && metric.status === 'invalid_inputs') return 'N/A';
    if (!metric || metric.status === 'no_data') return '0';
    if (UNAVAILABLE.has(metric.status)) return '0';
    return Number.isFinite(Number(metric.oee)) ? String(Number(metric.oee)) : '0';
}

function metricTitle(metric) {
    if (metric && metric.status === 'invalid_inputs') return 'Check cycle time, recorded breaks and downtime quantities.';
    if (isCalculatedMetric(metric) && Number(metric.oee) === 0) return 'Calculated OEE is 0% for scheduled production.';
    return metric && UNAVAILABLE.has(metric.status)
        ? 'Planning schedule unavailable for this period.'
        : '';
}

function buildMetricIndex(rows, keyFn) {
    return new Map((rows || []).map(row => [keyFn(row), row]));
}

function isCalculatedMetric(metric) {
    return Boolean(metric)
        && metric.status === 'calculated'
        && Number.isFinite(Number(metric.oee));
}

module.exports = {
    buildMetricIndex,
    formatOeeMetric,
    isCalculatedMetric,
    metricTitle,
};
